module.exports = __webpack_public_path__ + "images/es-d4b3b6.png";